import * as React from 'react';
import { useMediaState } from '@platejs/media/react';
import { ResizableProvider } from '@platejs/resizable';
import { PlateElement, withHOC } from 'platejs/react';
import { cn } from 'src/lib/utils';

export const AudioElement = withHOC(ResizableProvider, function AudioElement(props) {
  const { align = 'center', readOnly, unsafeUrl } = useMediaState();

  return (
    <PlateElement {...props} className="mb-1">
      <figure className="group relative cursor-default" contentEditable={false}>
        <div className={cn('h-16 rounded-sm')}>
          <audio className="size-full" src={unsafeUrl} controls />
        </div>
      </figure>
      {props.children}
    </PlateElement>
  );
});
